import React from 'react';
import PropTypes from 'prop-types';
// common components
import FormField from './../../../common/Forms/FormField/FormField';

const ManageCourse = ({ onDelete, onClone, onActivate, onChange, value }) => {

	if(onDelete) {
		return (
			<div className='ManageCourse'>
				<div>Are you sure, you want to delete?</div>
			</div>
		);
	};

	if(onClone) {
		return (
			<div className='ManageCourse'>
				<FormField
				label="Course Name"
				name="name"
				type="text"
				placeholder="enter Course Name"
				value= {value.name}
				// onChange={ onChange }
				validate={['required']}
                maxLength={50}
			/>
			<FormField
				label="Cloned Course Name"
				name="clonedCourseName"
				type="text"
				placeholder="enter Course Name"
				value= {value.clonedCourseName}
				onChange={ onChange }
				validate={['required']}
                maxLength={50}
				autoFocus
			/>
			</div>
		);
	};

	if(onActivate) {
		return (
			<div className='ManageCourse'>
				<div>Are you sure, you want to activate course?</div>
			</div>
		);
	};

	// componentDidMount(){
	// 	this.nameInput.focus();
	//   }
	return (
		<div className='ManageCourse'>
			<FormField
				label="Course Name"
				name="name"
				type="text"
				placeholder="enter Course Name"
				value= {value.name}
				onChange={ onChange }
				validate={['required']}
                maxLength={50}
				autoFocus
				// ref={(input) => { this.nameInput = input; }} 
				// defaultValue="will focus"
			/>
			<FormField
				label="Description"
				name="description"
				type="text"
				multiline
				placeholder="enter Description"
				value= {value.description}
				onChange={ onChange }
			/>
		</div>
	);
}

ManageCourse.propTypes = {
	value: PropTypes.instanceOf(Object),
	onDelete: PropTypes.bool,
	onChange: PropTypes.func
};

ManageCourse.defaultProps = {
	value: {},
	onDelete: false,
	onChange: () => {}
};

export default ManageCourse;



// WEBPACK FOOTER //
// ./components/Course/ManageCourse/ManageCourse.js